import {
  mdiPlusCircle,
  mdiCheckCircleOutline,
  mdiCheckboxBlankCircleOutline,
  mdiAlert,
} from '@mdi/js'

import {
  WizardStepsBlock,
  WizardStepsContainer,
  WizardStepsErrorWrapper,
  WizardStepsIcon,
  WizardStepsIconCurrent,
  WizardStepsIconSuccess,
  WizardStepsIconUnselected,
  WizardStepsTitle,
} from 'components/WizardSteps/styles'
import theme from 'theme_'

interface WizardStepData {
  id: number
  title: string
}

interface WizardStepsProps {
  currentWizardStepId: number
  stepsData: WizardStepData[]
  hasError?: boolean
}

function WizardSteps({
  currentWizardStepId,
  stepsData,
  hasError = false,
}: WizardStepsProps) {
  return (
    <WizardStepsContainer>
      {stepsData.map((step) => (
        <WizardStepsBlock key={step.id}>
          {step.id === currentWizardStepId && (
            <WizardStepsIconCurrent path={mdiPlusCircle} />
          )}
          {step.id < currentWizardStepId && (
            <WizardStepsIconSuccess path={mdiCheckCircleOutline} />
          )}
          {step.id > currentWizardStepId && (
            <WizardStepsIconUnselected path={mdiCheckboxBlankCircleOutline} />
          )}
          <WizardStepsTitle
            selected={step.id === currentWizardStepId}
            isGrey={currentWizardStepId < step.id}
          >
            {step.title}
          </WizardStepsTitle>
          {hasError && step.id === currentWizardStepId - 1 && (
            <WizardStepsErrorWrapper>
              <WizardStepsIcon
                path={mdiAlert}
                size={1}
                color={theme.colors.error}
              />
            </WizardStepsErrorWrapper>
          )}
        </WizardStepsBlock>
      ))}
    </WizardStepsContainer>
  )
}

export default WizardSteps
